/**
 * Tap fix dos cards de produto (product-list).
 *
 * Carregado como módulo ES: o navegador avalia a mesma URL uma única vez,
 * mesmo com várias seções product-list na página (a home tem 9).
 * Cada raiz de seção é marcada com [data-product-list-tapfix] no Liquid.
 *
 * Comportamento: no toque, um tap curto dentro do card navega para o produto;
 * se o toque cair sobre o botão de Quick Add, o botão tem prioridade.
 * Swipe (movimento > 8px) libera o gesto para o carrossel.
 */
function initTapFix(root) {
  if (!root || root.__tapFixV5) return;
  root.__tapFixV5 = true;

  var downX = 0,
    downY = 0,
    moved = false,
    card = null,
    anchor = null,
    quickBtn = null,
    skip = false,
    handled = false;

  // BOTÃO real de Quick Add (apenas elementos clicáveis)
  var QA_BUTTON_SEL = [
    'button[name="add"]',
    'button[data-add-to-cart]',
    'button.quick-add',
    'button.quick-add__button',
    '[type="submit"][name="add"]',
    'a[role="button"][data-add-to-cart]',
  ].join(',');

  // Áreas interativas que não queremos interceptar
  var IGNORE_SEL = [
    'input',
    'select',
    'textarea',
    'label',
    '[contenteditable]',
    '.shopify-payment-button, .shopify-payment-button *',
    '[data-action]',
  ].join(',');

  // Link do produto dentro do card
  var PRODUCT_LINK_SEL = 'a[href*="/products/"]:not([href^="#"]):not([role="button"])';

  function isTouchLike(e) {
    return (e.pointerType && e.pointerType !== 'mouse') || e.type.indexOf('touch') === 0;
  }
  function pt(e) {
    var t = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
    return { x: t.clientX, y: t.clientY };
  }

  // Encontra o botão de Quick Add exatamente sob o ponto (respeita overlays)
  function quickAddAtPoint(x, y) {
    var stack = document.elementsFromPoint(x, y) || [];
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      var btn = el.closest && el.closest(QA_BUTTON_SEL);
      if (btn) return btn;
    }
    return null;
  }

  function onDown(e) {
    if (!isTouchLike(e)) return;
    var p = pt(e);
    downX = p.x;
    downY = p.y;
    moved = false;
    skip = false;
    quickBtn = null;
    handled = false;

    card = e.target.closest('.resource-list__item');
    if (!card) {
      anchor = null;
      return;
    }

    // 1) Se o toque caiu sobre o botão de Quick Add → prioriza botão
    quickBtn = quickAddAtPoint(p.x, p.y);
    if (quickBtn) {
      anchor = null;
      return;
    }

    // 2) Se tocou em algo interativo que não é o botão, não intercepta
    if (e.target.closest(IGNORE_SEL)) {
      skip = true;
      anchor = null;
      return;
    }

    // 3) Se tocou num <a> que não é link de produto, não intercepta
    var a = e.target.closest('a[href]');
    if (a && !a.matches(PRODUCT_LINK_SEL)) {
      skip = true;
      anchor = null;
      return;
    }

    // 4) Seleciona link de produto do card
    anchor = a && a.matches(PRODUCT_LINK_SEL) ? a : card.querySelector(PRODUCT_LINK_SEL);
  }

  function onMove(e) {
    if (!isTouchLike(e)) return;
    var p = pt(e);
    if (Math.abs(p.x - downX) > 8 || Math.abs(p.y - downY) > 8) moved = true; // libera swipe
  }

  function stopAll(e) {
    if (e.cancelable) e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function onUp(e) {
    if (!isTouchLike(e)) return;

    // 2ª notificação (pointer+touch) do MESMO toque já tratado: ainda suprime
    // o evento/click nativo remanescente (fantasma), sem repetir a ação.
    if (handled) { stopAll(e); handled = false; return; }

    // Tap curto no botão de Quick Add → clicar imediatamente
    if (quickBtn && !moved) {
      handled = true;
      stopAll(e);
      try {
        quickBtn.click();
      } catch (_) {}
      quickBtn = null;
      card = null;
      anchor = null;
      return;
    }

    // Tap curto no card → navegar ao produto
    if (card && anchor && !moved && !skip) {
      handled = true;
      stopAll(e);
      window.location.assign(anchor.href);
    }

    card = null;
    anchor = null;
    quickBtn = null;
  }

  // listeners em captura (antes do slider)
  root.addEventListener('pointerdown', onDown, { capture: true, passive: true });
  root.addEventListener('pointermove', onMove, { capture: true, passive: true });
  root.addEventListener('pointerup', onUp, { capture: true, passive: false });
  // fallback iOS
  root.addEventListener('touchstart', onDown, { capture: true, passive: true });
  root.addEventListener('touchmove', onMove, { capture: true, passive: true });
  root.addEventListener('touchend', onUp, { capture: true, passive: false });
}

const ROOT_SEL = '[data-product-list-tapfix]';

function initWithin(scope) {
  if (!scope) return;
  if (scope.matches && scope.matches(ROOT_SEL)) initTapFix(scope);
  if (scope.querySelectorAll) {
    scope.querySelectorAll(ROOT_SEL).forEach(initTapFix);
  }
}

initWithin(document);

// Editor de temas: a seção é re-renderizada sem recarregar a página.
document.addEventListener('shopify:section:load', (event) => {
  initWithin(event.target);
});
